import { Slot } from '@radix-ui/react-slot';

import { cn } from '@/lib/utils';

const BASE_CLASS = 'mm-widget';

export type WidgetProps = React.ComponentProps<'div'> & {
  asChild?: boolean;
};

export const Widget = ({ asChild, className, ...others }: WidgetProps) => {
  const Comp = asChild ? Slot : 'div';
  return (
    <Comp
      data-slot="widget"
      className={cn(`${BASE_CLASS} mm-styled relative`, className)}
      {...others}
    />
  );
};
